import React, {useCallback, useEffect, useState} from 'react';
import '../assets/css/emi.css';
import config from 'config'

const API_LIMIT_COOLDOWN_TIME = 60;

const EMICalculator = () => {

    const [state, setState] = useState({
        showMenu: false,
        interestRate: 0,
        interestRateMy: '',
        loanAmountBar: 100000,
        interestBar: 18,
        loanTermBar: 21,
        terms: undefined,
        showMenuOverlay: false,
        eligibility: false,
        inputVal: '',
        balance: 1,
        interestType: '',
        monthlyPayment: 0,
        totalAmount: 0,
        totalInterestPayable: 0,
        errors: '',
        successMessage: false,
        loader: false,
        max_loan_amount: '',
        max_loan_term_months: '',
        max_yearly_interest_rate: '',
        min_loan_amount: '',
        min_loan_term_months: '',
        min_yearly_interest_rate: 1,
        processing_charge: '',
        name: '',
        emailId: '',
        dob: '',
        pinCode: '',
        radio1: '',
        radio2: '',
        monthlyIncome: '',
        loanAmount: '',
        loanTerm: '',
        eligible: undefined,
        message: "",
        error: false,
        interestPayable: 0,
        showEligibilityScreen: false,
        showLinksToApplyLoan: false,
        isEmptyCalc: false
    })

    const [apiLimitExceeded, setApiLimitExceeded] = useState(false);
    const [apiLimitCooldownTimer, setApiLimitCooldownTimer] = useState(API_LIMIT_COOLDOWN_TIME);
    useEffect(() => {
        let timeout;
        if (apiLimitExceeded) {
            timeout = setTimeout(() => {
                const nextValueForCooldown = apiLimitCooldownTimer - 1
                if (nextValueForCooldown === 0) {
                    setApiLimitExceeded(false);
                    setApiLimitCooldownTimer(API_LIMIT_COOLDOWN_TIME);
                } else {
                    setApiLimitCooldownTimer(nextValueForCooldown);
                }
            }, 1000);
        }

        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        }
    }, [apiLimitExceeded, apiLimitCooldownTimer]);

    useEffect(() => {
        initValue()
    }, [])

    const escFunction = useCallback((event) => {
        if (state.inputVal !== '' && state.totalAmount !== '') {
            if (event.key === "Escape") {
                setState({...state, showMenuOverlay: false, eligibility: false})
            }
        }
    }, [state]);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);

    const handleClickOutside = useCallback((e) => {
        let container = document.getElementById('calc-section-container');
        if (!container.contains(e.target)) {
            setState({...state, showMenuOverlay: false, eligibility: false})
        }
    }, [state]);

    useEffect(() => {
        document.addEventListener("mouseup", handleClickOutside, false);
        return () => {
            document.removeEventListener("mouseup", handleClickOutside, false);
        };
    }, [handleClickOutside]);

    useEffect(() => {
        if (state.showMenuOverlay === true) {
            setState({...state, eligibility: false})
        }

        if (state.eligibility === true) {
            setState({...state, showMenuOverlay: false})
        }
    }, [state.showMenuOverlay, state.eligibility])

    useEffect(() => {
        if (state.isEmptyCalc === true) checkAmount()
    }, [state.isEmptyCalc])

    useEffect(() => {
        if (state.interestType !== '') {
            checkAmount()
        }
    }, [state.interestType])

    const handleValidation = (e) => {
        if (['pinCode', 'monthlyIncome', 'loanAmount', 'loanTerm'].includes(e.target.name)) {
            let numbers = /^[0-9]+$/;
            if (!e.target.value.match(numbers)) {
                setState({...state, errors: "Not a Valid Number"})
            } else if (e.target.name === 'pinCode' && e.target.value.length > 6) {
                setState({...state, errors: "Number greater than 6"})
            } else if (e.target.name === 'loanTerm' && e.target.value.length > 2) {
                setState({...state, errors: "Number greater than 2"})
            } else if (e.target.value.length > 10) {
                setState({...state, errors: "Number greater than 10"})
            }
        } else if (e.target.name === 'name') {
            let spacedString = /^[a-zA-Z ]*$/;
            if (!e.target.value.match(spacedString)) {
                setState({...state, errors: "Not a Valid Name"})
            }
        }
    }

    const onChangeValue = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        })
        handleValidation(e)
    }

    const onChangeRadio = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        })
    }

    const initValue = () => {
        fetch(`${config.REV_URL}/getallLoanSettingData`, {
            method: 'get'
        })
            .then(res => res.json())
            .then(res => {
                const format = num => {
                    const n = String(num),
                        p = n.indexOf('.')
                    return n.replace(
                        /\d(?=(?:\d{3})+(?:\.|$))/g,
                        (m, i) => p < 0 || i < p ? `${m},` : m
                    )
                }
                let initvalue = res.data[0]
                setState({
                    ...state,
                    max_loan_amount: initvalue.max_loan_amount,
                    max_loan_term_months: initvalue.max_loan_term_months,
                    max_yearly_interest_rate: initvalue.max_yearly_interest_rate,
                    min_loan_amount: initvalue.min_loan_amount,
                    min_loan_term_months: initvalue.min_loan_term_months,
                    min_yearly_interest_rate: initvalue.min_yearly_interest_rate,
                    processing_charge: initvalue.processing_charge,
                    interestRateMy: 18,
                    terms: 21,
                    inputVal: '100000',
                    interestType: 'reducing',

                })
            }).catch((err) => {
            console.log(err)
        })
    }

    const closeCalculator = () => {
        setState({
            ...state,
            showMenuOverlay: false,
            eligibility: false,
            successMessage: false,
            loader: false,
            showMenu: false
        })
    }
    const flatEMI = (param) => {
        let balance = parseInt(param.balance)
        let interestRate = parseInt(param.interestRate)
        let terms = parseInt(param.terms)

        if (!balance || !interestRate || !terms) {
            return (
                {
                    "balance": "---",
                    "monthlyPayment": "---",
                    "totalAmount": "---",
                    "interestRate": interestRate,
                    "interestPayable": "---"
                }
            )
        } else {
            let totalInterest = ((balance * interestRate * terms / 12) / (100))
            let totalPayable = (balance + totalInterest).toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                currency: 'INR'
            });
            let emi = (balance + totalInterest) / (terms)
            let emiToFixedCommas = emi.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                currency: 'INR'
            });

            return ({
                "balance": balance,
                "monthlyPayment": emiToFixedCommas,
                "totalAmount": totalPayable,
                "interestRate": interestRate,
                "interestPayable": totalInterest.toLocaleString('en-IN', {
                    maximumFractionDigits: 2,
                    currency: 'INR'
                })
            })
        }
    }

    const reducingEMI = (param) => {
        const {balance, interestRate, terms} = param;
        let monthlyRate;
        let emi;
        let totalInterest;
        let totalPayable;
        let emiToFixed;

        if (!balance || !interestRate || !terms || interestRate === 0 || terms === 0) {
            return ({
                "balance": "---",
                "monthlyPayment": "---",
                "totalAmount": "---",
                "interestRate": interestRate,
                "interestPayable": "---"
            })
        } else {
            monthlyRate = (interestRate / (12 * 100));
            emi = ((balance * monthlyRate * ((1 + monthlyRate) ** terms)) / (((1 + monthlyRate) ** terms) - 1))
            totalInterest = (emi * terms - balance).toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                currency: 'INR'
            });
            totalPayable = (emi * terms).toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                currency: 'INR'
            });
            emiToFixed = emi.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                currency: 'INR'
            });
            return (
                {
                    "balance": balance,
                    "monthlyPayment": emiToFixed,
                    "totalAmount": totalPayable,
                    "interestRate": interestRate,
                    "interestPayable": totalInterest
                })
        }

    }
    const forms = {
        balance: state.inputVal,
        interestRate: state.interestRateMy,
        terms: state.terms,
        interestType: state.interestType
    }

    const checkAmount = () => {

        let values;
        if (state.interestType === 'flat') {
            values = flatEMI(forms)
        }
        if (state.interestType === 'reducing') {
            values = reducingEMI(forms)
        }

        setState({
            ...state,
            balance: values.balance,
            monthlyPayment: values.monthlyPayment,
            totalAmount: values.totalAmount,
            totalInterestPayable: values.interestPayable,
            isEmptyCalc: false
        })
    }

    useEffect(() => {
        let values
        if (state.interestType === 'flat') {
            values = flatEMI(forms)
            console.log("flat is ", values)
        } else if (state.interestType === 'reducing') {
            values = reducingEMI(forms)
            console.log("reducing is", values)
        }

        if (values && values.balance) {
            checkAmount()
        }
    }, [state.inputVal, state.interestRateMy, state.terms, state.interestType])

    const debounce = (fn, wait) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn(...args), wait);
        }
    }
    const debounceLog = () => debounce(() => checkAmount(), 2000)

    const updateLoanAmountRange = (e) => {
        let regex = /[^0-9]/gi;
        e.target.value = e.target.value.replace(regex, "");
        if (e.target.value > state.max_loan_amount) e.target.value = state.max_loan_amount
        // setState({...state, inputVal: e.target.value})
        setState({...state, inputVal: e.target.value, loanAmountBar: e.target.value || 0})
        debounceLog();
    }

    const updateInterestRange = (e) => {
        let regex = /[^0-9]/gi;
        e.target.value = e.target.value.replace(regex, "");
        if (e.target.value > state.max_yearly_interest_rate) e.target.value = state.max_yearly_interest_rate
        setState({...state, interestRateMy: e.target.value, interestBar: e.target.value || 0})
        debounceLog();
    }

    const updateTermRange = (e) => {
        let regex = /[^0-9]/gi
        e.target.value = e.target.value.replace(regex, "")
        if (e.target.value > state.max_loan_term_months) e.target.value = state.max_loan_term_months
        setState({...state, terms: e.target.value, loanTermBar: e.target.value || 0})
        debounceLog();
    }


    const onLoanAmountBlur = (e) => {
        if (e.target.value === '0' || e.target.value === '') {
            setState({...state, inputVal: '1', isEmptyCalc: true})
        } else if (e.target.value > state.max_loan_amount) {
            setState({...state, inputVal: state.max_loan_amount, isEmptyCalc: true})
        } else {
            checkAmount()
        }
    }

    const onInterestRateBlur = (e) => {
        if (e.target.value === '0' || e.target.value === '') {
            setState({...state, interestRateMy: '1', isEmptyCalc: true})

        } else if (e.target.value > state.max_yearly_interest_rate) {
            setState({...state, interestRateMy: state.max_yearly_interest_rate, isEmptyCalc: true})
        } else {
            checkAmount()
        }

    }

    const onTermsInputBlur = (e) => {
        if (e.target.value === '0' || e.target.value === '') {
            setState({...state, terms: 1, isEmptyCalc: true})
        } else if (e.target.value > state.max_loan_term_months) {
            setState({...state, terms: state.max_loan_term_months, isEmptyCalc: true})
        } else {
            checkAmount()
            setState({...state, isEmptyCalc: false})
        }
    }

    const submitData = (e) => {
        e.preventDefault();
        setState({...state, showEligibilityScreen: true})
        let form = JSON.stringify({
            name: state.name,
            emailid: state.emailId,
            dob: state.dob,
            pincode: state.pinCode,
            occupation: state.radio1,
            loanproductid: state.radio2,
            monthlyincome: state.monthlyIncome,
            loanamount: state.loanAmount,
            loanterm: state.loanTerm,
        })
        fetch(`${config.REV_URL}/eligibilitycheckNew`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: form
        })
            .then(response => response.json())
            .then(res => {
                if (res.status === 200) {
                    if (res.error === true) {
                        setState({
                            ...state,
                            message: res.message,
                            eligible: false,
                            error: res.error,
                            successMessage: false,
                            showEligibilityScreen: true
                        })
                    } else if (res.error === false) {
                        setState({
                            ...state,
                            message: res.message,
                            eligible: typeof (res.eligible) !== "boolean" ? false : res.eligible,
                            error: res.error,
                            successMessage: true,
                            showEligibilityScreen: true
                        })
                    } else {
                        console.log("Couldn't process request")
                        setState({
                            ...state,
                            showEligibilityScreen: false
                        });
                    }
                } else if (res.status === 429) {
                    setState({
                        ...state,
                        showEligibilityScreen: false
                    });
                    setApiLimitExceeded(true);
                }
            });
    }

    return (
        <section className='section-padding' id='calc-section-container'>
            <div className="row">
                <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                    <div className="section-titles">
                        <h3 className="heading_tow">CHECK YOUR EMI</h3>
                    </div>
                    <div className="emi_vtn"
                         onClick={() => setState({...state, showMenu: true, showMenuOverlay: true})}>
                        <ul>
                            <li><a onClick={(e) => {
                                e.preventDefault()
                            }}>EMI Calculator</a></li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                    <div className="section-titles">
                        <h3 className="heading_tow">CHECK YOUR ELIGIBILITY</h3>
                    </div>
                    <div className="emi_vtn"
                         onClick={() => setState({...state, showMenu: true, eligibility: true})}>
                        <ul>
                            <li><a onClick={(e) => e.preventDefault()}>Eligibility Check</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            {state.showMenuOverlay === true &&
                <div className={`calculator ${state.showMenuOverlay ? 'showCalcu' : ''}`}>
                    <div className="firstcal">
                        <div className="calheader" style={{
                            display: 'flex',
                            alignItems: 'baseline'
                        }}>
                            <div className="content dblue">EMI Calculator</div>

                            <div className="closecal" onClick={closeCalculator}><img
                                src={require('../images/close.png')} alt=""/></div>
                        </div>
                        <div className="toggle-switch">
                            <div className="pricing-toggle">
                                <div style={{backgroundColor: '#EBEBE4', borderRadius: '30px', display: 'flex'}}>
                                    <div>
                                        <input type="radio" id="pricing-toggle-annually" name="pricing" value="reducing"
                                               checked={state.interestType === 'reducing'}
                                               onClick={(e) => setState({
                                                   ...state,
                                                   interestType: e.target.value
                                               })}/>
                                        <label className="radio-button"
                                               htmlFor="pricing-toggle-annually"> Reducing</label>
                                    </div>
                                    <div>
                                        <input type="radio" id="pricing-toggle-monthly" name="pricing" value="flat"
                                               checked={state.interestType === 'flat'}
                                               onClick={(e) => setState({
                                                   ...state,
                                                   interestType: e.target.value
                                               })}/>
                                        <label className="radio-button"
                                               htmlFor="pricing-toggle-monthly">Flat</label>
                                    </div>
                                </div>
                            </div>
                            <h5 className="content-interest dblue">Interest Rate</h5>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '95%',
                            margin: 'auto',
                            marginBottom: '1rem'
                        }}>
                            <div className="calinput">
                                <div className="outputdata">
                                    <label className="calinlabel">Loan Amount</label>
                                    <div className="full-w">
                                        <input type="text" maxLength="9" className="full-w inputfiled"
                                               onChange={updateLoanAmountRange}
                                               onBlur={onLoanAmountBlur}
                                               value={Number(state.inputVal).toLocaleString('en-IN', {
                                                   maximumFractionDigits: 0,
                                                   currency: 'INR'
                                               })}/>
                                    </div>
                                    <div className="relative full-w mgt-25">
                                        <input id="range" type="range" style={{cursor: 'pointer'}}
                                               className="full-w"
                                            // value={Number(state.inputVal)}
                                               value={state.loanAmountBar}
                                               min={state.min_loan_amount}
                                               max={state.max_loan_amount}
                                               step="1"
                                               onChange={updateLoanAmountRange}
                                               onMouseUp={checkAmount}/>
                                    </div>
                                    <div className="full-w myflex f-between myflexRes mgt-5">
                                        <div className="bbfont displayToBeg"><span className="rsposition"></span>
                                            ₹ {state.min_loan_amount.toLocaleString('en-IN', {
                                                maximumFractionDigits: 0,
                                                currency: 'INR'
                                            })}
                                        </div>
                                        <div className="bbfont displayToEnd"><span className="rsposition"></span>
                                            ₹ {state.max_loan_amount.toLocaleString('en-IN', {
                                                maximumFractionDigits: 0,
                                                currency: 'INR'
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="outputdata">
                                <label className="calinlabel">Interest Rate</label>
                                <div className="full-w">
                                    <input type="text" maxLength="2" className="full-w inputfiled"
                                           onChange={updateInterestRange}
                                           onBlur={onInterestRateBlur}
                                           value={state.interestRateMy}/>
                                </div>

                                <div className="relative full-w mgt-25">
                                    <input id="range" type="range" className="full-w" style={{cursor: 'pointer'}}
                                           value={state.interestBar}
                                           min={state.min_yearly_interest_rate}
                                           max={state.max_yearly_interest_rate}
                                           step="1"
                                           onChange={updateInterestRange}
                                           onMouseUp={checkAmount}/>
                                </div>

                                <div className="full-w myflex f-between myflexRes mgt-5">
                                    <div className="bbfont displayToBeg">{state.min_yearly_interest_rate}% p.a</div>
                                    <div className="bbfont displayToEnd">{state.max_yearly_interest_rate}% p.a</div>
                                </div>
                            </div>

                            <div className="outputdata">
                                <label className="calinlabel">Loan Term</label>
                                <div className="full-w">
                                    <input type="text" maxLength="2" className="full-w inputfiled"
                                           onChange={updateTermRange}
                                           onBlur={onTermsInputBlur}
                                           value={state.terms}/>
                                </div>
                                <div className="relative full-w mgt-25">
                                    <input id="range" type="range" className="full-w" style={{cursor: 'pointer'}}
                                           value={state.loanTermBar}
                                           min={state.min_loan_term_months}
                                           max={state.max_loan_term_months}
                                           step="1"
                                           onChange={updateTermRange}
                                           onMouseUp={checkAmount}/>
                                </div>
                                <div className="full-w myflex f-between myflexRes mgt-5">
                                    <div className="bbfont displayToBeg">{state.min_loan_term_months} Months</div>
                                    <div className="bbfont displayToEnd">{state.max_loan_term_months} Months</div>
                                </div>
                            </div>

                        </div>

                        <div className="secondcal">
                            <b className="emipayable full-w" style={{textAlign: 'center'}}><span
                                style={{color: '#f7e5db'}}>EMI Payable:</span> ₹ {state.monthlyPayment}</b>
                            <div className="full-w mgt-15 myflex myflexRes f-between f-center"
                                 style={{display: "flex", justifyContent: 'space-around'}}>
                                <div className="calculations">
                                    <div className="full-w calinlabel emiwhite">Interest Payable</div>
                                    <div className="full-w">₹ {state.totalInterestPayable}</div>
                                </div>

                                <div className="calculations">
                                    <div className="full-w calinlabel emiwhite" style={{textAlign: 'end'}}>Total
                                        Payable
                                    </div>
                                    <div className="full-w">₹ {state.totalAmount}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

            {state.eligibility === true && <div className={`calculator ${state.eligibility ? 'showCalcu' : ''}`}>
                <div className="firstcal pd-mm overauto">
                    {state.showEligibilityScreen ? <div className="notsuccess show">
                        {state.eligible === true ?
                            <div className={(state.error === false) ? "sucesswala show" : "sucesswala"}>
                                {state.showLinksToApplyLoan === true ? <div>
                                        <div className="colseBtnsco" onClick={() => setState({
                                            ...state,
                                            eligibility: false,
                                            showEligibilityScreen: false,
                                            showLinksToApplyLoan: false
                                        })}>x
                                        </div>
                                        <h3>Congratulations</h3>
                                        <img src={require('../images/happy.gif')} alt=""/>
                                        <div className="urllist">
                                            <div className="app_icon">
                                                <ul className="myflex flex-between">
                                                    <li><a href="https://apps.apple.com/in/app/revfin/id1454364758"
                                                           target="_blank" rel="noopener noreferrer">
                                                        <div className="icon_body">
                                                            <div className="icon-left pro1"></div>
                                                            <div className="icon-content"><p>Available on </p><h4><b>App
                                                                Store</b></h4></div>
                                                        </div>
                                                    </a></li>
                                                    <li><a
                                                        href="https://play.google.com/store/apps/details?id=com.revfin_ptech18"
                                                        target="_blank" rel="noopener noreferrer">
                                                        <div className="icon_body">
                                                            <div className="icon-left pro2"></div>
                                                            <div className="icon-content"><p>Available on </p><h4><b>Google
                                                                play</b></h4></div>
                                                        </div>
                                                    </a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> :
                                    <div className={`successMessage ${state.successMessage ? 'showsccess' : ''}`}>
                                        <div className="colseBtnsco" onClick={() => setState({
                                            ...state,
                                            eligibility: false,
                                            showEligibilityScreen: false,
                                            showLinksToApplyLoan: false
                                        })}>x
                                        </div>
                                        <div className="Contrats" style={{marginBottom: '1rem'}}>
                                            <img src={require('../images/approval.png')} alt=""
                                                 style={{width: 'auto'}}/>
                                            <p>Congratulations! You are eligible to apply for a loan.</p>
                                            <a href="#app_work" className="submitbutton donebtn" onClick={() => {
                                                closeCalculator();
                                                setState({...state, showLinksToApplyLoan: true})
                                            }}>Apply Now</a>
                                        </div>
                                    </div>}
                            </div> :
                            <div className={(state.eligible === false) ? "sorryw show" : "shorryw"}>
                                <div className="colseBtnsco" onClick={() => setState({
                                    ...state,
                                    eligibility: false,
                                    showEligibilityScreen: false,
                                    showLinksToApplyLoan: false
                                })}>x
                                </div>
                                <h3>Sorry</h3>
                                <img src={require('../images/sad.gif')} alt=""/>
                                <p>{state.message}</p>
                            </div>}
                    </div> : <div>
                        <div className={`calheader ${state.successMessage ? 'd-none' : ''}`}>
                            <div className="content dblue">Eligibility Check</div>
                            <div className="closecal" onClick={closeCalculator}><img
                                src={require('../images/close.png')} alt=""/></div>
                        </div>
                        <form onSubmit={submitData}
                              className={`${state.successMessage ? 'd-none' : ''}`}>
                            <div className="calbody">
                                <div className="full-w">
                                    <div className="form-group">
                                        <input type="text" name="name" className="form-control btbottom"
                                               style={{backgroundColor: '#f6f6f6'}}
                                               required value={state.name}
                                               onChange={onChangeValue}
                                        />
                                        <label className="form-control-placeholder">Name</label>
                                    </div>

                                </div>
                                <div className="full-w">
                                    <div className="form-group">
                                        <input type="email" name="emailId" className="form-control btbottom"
                                               style={{backgroundColor: '#f6f6f6'}}
                                               required value={state.emailId}
                                               onChange={onChangeValue}
                                        />
                                        <label className="form-control-placeholder">Email</label>
                                    </div>
                                </div>
                                <div className="full-w">
                                    <div className="form-group">
                                        <input type="date" name="dob" className="form-control btbottom dateofBirth"
                                               style={{backgroundColor: '#f6f6f6'}}
                                               required value={state.dob}
                                               onChange={onChangeValue}
                                        />
                                        <label className="form-control-placeholder abarslec">Date Of Birth</label>
                                    </div>
                                </div>
                                <div className="full-w">
                                    <div className="form-group">
                                        <input type="text" name="pinCode" className="form-control btbottom"
                                               style={{backgroundColor: '#f6f6f6'}}
                                               required value={state.pinCode}
                                               onChange={onChangeValue}
                                        />
                                        <label className="form-control-placeholder">Pin Code</label>
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="ocupationAre">
                                    <h3>Occupation</h3>
                                    <label className="Radiocont rightm">
                                        <input type="radio" name="radio1"
                                               onChange={onChangeRadio}
                                               value="Salaried"/>
                                        <span className="checkmark">Salaried</span>
                                    </label>
                                    <label className="Radiocont">
                                        <input type="radio" name="radio1"
                                               onChange={onChangeRadio}
                                               value="Self Employed"/>
                                        <span className="checkmark">Self Employed</span>
                                    </label>
                                </div>
                                <div className="ocupationAre">
                                    <h3>Loan Type</h3>
                                    <label className="divradio">
                                        <input type="radio" name="radio2"
                                               onChange={onChangeRadio}
                                               value="5e8c3bd323c56a069a0a1836"/>Electric Three Wheeler loan
                                        <span className="marko"></span>
                                    </label>
                                    <label className="divradio">
                                        <input type="radio" name="radio2"
                                               onChange={onChangeRadio}
                                               value="5e8c408123c56a069a0a1837"/>Electric Two Wheeler Loan
                                        <span className="marko"></span>
                                    </label>
                                    <label className="divradio">
                                        <input type="radio" name="radio2"
                                               onChange={onChangeRadio}
                                               value="5ee859f9441ec6f8d2e6f173"/>
                                        EV Ancillary Loan
                                        <span className="marko"></span>
                                    </label>
                                </div>
                                <div className="full-w">
                                    <div className="form-group">
                                        <input type="text" name="monthlyIncome" className="form-control btbottom"
                                               style={{backgroundColor: '#f6f6f6'}}
                                               required value={state.monthlyIncome}
                                               onChange={onChangeValue}
                                        />
                                        <label className="form-control-placeholder">Monthly Income (In Rupees)</label>
                                    </div>
                                </div>
                                <div className="full-w">
                                    <div className="form-group">
                                        <input type="text" name="loanAmount" className="form-control btbottom"
                                               style={{backgroundColor: '#f6f6f6'}}
                                               required value={state.loanAmount}
                                               onChange={onChangeValue}
                                        />
                                        <label className="form-control-placeholder">Loan Amount (In Rupees)</label>
                                    </div>
                                </div>
                                <div className="full-w">
                                    <div className="form-group">
                                        <input type="text" name="loanTerm" className="form-control btbottom"
                                               style={{backgroundColor: '#f6f6f6'}}
                                               required value={state.loanTerm}
                                               onChange={onChangeValue}
                                        />
                                        <label className="form-control-placeholder">Loan Term (In Months)</label>
                                    </div>

                                </div>
                                <div className="full-w text-center">
                                    <button type="submit" disabled={apiLimitExceeded} className="btn submitbutton mgt-5">Apply Now</button>
                                    {apiLimitExceeded && (
                                        <div style={{
                                            marginTop: '10px',
                                            fontSize: '14px',
                                            color: 'red',
                                            textAlign: 'center'
                                        }}>
                                            Too many requests!<br/>Please wait {apiLimitCooldownTimer} seconds before trying again.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>}
                </div>
            </div>}
        </section>
    )
};

export default EMICalculator;


// WEBPACK FOOTER //
// ./src/components/EMICalculator.js